module fdm.general {
    export class GeneralService {
      
    }

    angular.module('fdm.general')
        .service('generalService', GeneralService);
}